import { render, staticRenderFns } from "./PaymentDetails.vue?vue&type=template&id=47c41da2&"
import script from "./PaymentDetails.vue?vue&type=script&lang=js&"
export * from "./PaymentDetails.vue?vue&type=script&lang=js&"
import style0 from "./PaymentDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports